export const setREPORTSOBJECT = "setREPORTSOBJECT";
